import {
  getData,
  postData
} from './api-base.service'

export const saveAd = (data) => postData('/studentAdvertisting/save', data)

export const queryAd = (params) => postData('/studentAdvertisting/queryAdvertising', params)

export const queryCurrentStudentAds = () => postData('/studentAdvertisting/queryCurrentStudentAds')

export const delAd = (id) => getData('/studentAdvertisting/remove?id=' + id)

export const switchAdEnabled = (id, enabled) => getData('/studentAdvertisting/switchEnabled?id=' + id + "&enabled=" + enabled)



// WEBPACK FOOTER //
// ./src/service/studentAd.service.js